import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "cruiseControl"
const CruiseControlIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M14.354 11.618C14.564 11.262 15.025 11.143 15.382 11.354 15.738 11.564 15.857 12.025 15.646 12.382L13.848 15.424C14.622 16.246 14.803 17.508 14.21 18.535 13.485 19.791 11.88 20.221 10.624 19.496 9.368 18.772 8.938 17.166 9.663 15.91 10.259 14.88 11.449 14.405 12.55 14.67zM12.5 16.248C11.96 15.939 11.273 16.123 10.962 16.66S10.836 17.886 11.374 18.197 12.6 18.324 12.91 17.785 13.037 16.56 12.499 16.25"
            clipRule="evenodd"
          />
          <path d="M12 3C13.936 3 15.836 3.536 17.487 4.548 19.137 5.559 20.477 7.008 21.355 8.733 22.235 10.46 22.62 12.393 22.468 14.324 22.316 16.254 21.633 18.104 20.495 19.671L19.28 18.791C20.257 17.447 20.842 15.86 20.972 14.205S20.772 10.893 20.02 9.414 18.117 6.694 16.702 5.826 13.66 4.5 12 4.5 8.713 4.96 7.298 5.826C5.883 6.694 4.734 7.936 3.981 9.414S2.898 12.552 3.028 14.206C3.158 15.861 3.744 17.448 4.719 18.79L3.505 19.671C2.367 18.105 1.685 16.254 1.532 14.324 1.38 12.394 1.766 10.459 2.645 8.734 3.524 7.007 4.863 5.558 6.514 4.547 8.164 3.536 10.064 3 12 3" />
          <path d="M5.974 14.25H3.724V12.75H5.974zM20.25 14.25H18V12.75H20.25zM8.121 8.936 7.061 9.996 5.47 8.406 6.53 7.344zM18.621 8.405 17.031 9.996 15.97 8.936 17.56 7.345zM12.75 7.5H11.25V5.25H12.75z" />
        </svg>
      }
    </span>
  )
}
export default CruiseControlIcon
